import React from 'react';
import { connect } from 'react-redux';
import cs from 'classnames';
import classes from './Footer.module.css';
import { toggleTerms } from '../../store/actions/termsAndConditionsActions';
import releaseLabel from '../../../version.txt';

const version = releaseLabel.trim();

const Footer = (props) => {
    const { displayFooter = false } = props;
    const defaultYear = 2019;
    var date = new Date();
    var currentYear = date.getFullYear();
    currentYear = currentYear !== defaultYear ? currentYear : null;
    const termsOfUsePopup = () => {
        props.toggleTerms(true);
    };

    const isTermsOlderThanAMonth = (createdAt) =>
        Math.round((new Date() - new Date(createdAt)) / (1000 * 60 * 60 * 24)) < 30;

    return (
        <div
            className={
                displayFooter ? cs('row no-gutters', classes.footer) : classes.footerPosition
            }
        >
            <div id={'div-copyright'}>
                Copyright &copy; {defaultYear},{currentYear} Trimble. All Rights Reserved.
            </div>
            {displayFooter ? (
                <React.Fragment>
                    &nbsp;|&nbsp;
                    <a
                        id={'link-privacy'}
                        target="_blank"
                        href="https://www.trimble.com/privacy"
                        rel="noreferrer"
                    >
                        <div className={classes.footerText}>Privacy</div>
                    </a>
                    &nbsp;|&nbsp;
                    <a id={'link-terms-of-use'} onClick={termsOfUsePopup}>
                        {props.termsNotify &&
                        isTermsOlderThanAMonth(props.termsAndConditions.created_at) ? (
                            <div className={cs(classes.footerTextUpdate)}>
                                Terms of Use (UPDATED)
                            </div>
                        ) : (
                            <div className={cs(classes.footerText)}>Terms of Use</div>
                        )}
                    </a>
                    {version ? (
                        <React.Fragment>
                            &nbsp;|&nbsp;
                            <div className={classes.footerText}>Version {version}</div>
                        </React.Fragment>
                    ) : null}
                </React.Fragment>
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => ({
    termsNotify: state.termsAndConditions.termsNotify,
    loggedInUserTerms: state.termsAndConditions.loggedInUserTerms,
    termsAndConditions: state.termsAndConditions.termsAndConditions
});
export default connect(mapStateToProps, { toggleTerms })(Footer);
